import * as React from "react";

// Global back-button stack: open dialogs get a history entry; back closes the top-most one first.
const stack = [];
let ignore = 0;
let queue = [];

if (typeof window !== "undefined") {
  window.addEventListener("popstate", (e) => {
    if (ignore > 0) {
      ignore -= 1;
      e.__backHandled = true;
      const q = queue; queue = [];
      q.forEach((f) => f());
      return;
    }
    const top = stack.pop();
    if (top) { top.popped = true; e.__backHandled = true; top.close(); }
  });
}

export function pushHistory(extra) {
  const run = () => window.history.pushState({ ...(window.history.state || {}), ...extra }, "");
  if (ignore > 0) queue.push(run); else run();
}

function openEntry(close) {
  const ent = { close, popped: false };
  stack.push(ent);
  pushHistory({ __dlg: Date.now() });
  return () => {
    const i = stack.indexOf(ent);
    if (i >= 0) stack.splice(i, 1);
    if (!ent.popped) { ignore += 1; window.history.back(); }
  };
}

// Wraps a Radix-style Root so the browser back button closes it.
export function withBackClose(Root) {
  const Wrapped = ({ open, defaultOpen, onOpenChange, ...props }) => {
    const [inner, setInner] = React.useState(!!defaultOpen);
    const controlled = open !== undefined;
    const isOpen = controlled ? open : inner;
    const change = React.useCallback((v) => { if (!controlled) setInner(v); onOpenChange?.(v); }, [controlled, onOpenChange]);
    const ref = React.useRef(change);
    ref.current = change;
    React.useEffect(() => {
      if (!isOpen) return undefined;
      return openEntry(() => ref.current(false));
    }, [isOpen]);
    return <Root open={isOpen} onOpenChange={change} {...props} />;
  };
  return Wrapped;
}
